import React from 'react';
import { ChevronRight, ArrowLeft } from 'lucide-react';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';

import './style.css';

const DatapointHistory = ({ historyItem, returnTo, returnToFunction }) => {
    console.log('historyItem:', historyItem);
    // Sort timeline with newest first
    const sortedTimeline = [...historyItem.timeline.timeline].sort((a, b) => b.time - a.time);

    return (
        <div className="datapoint-history">
            <button 
                className="back-to-datapoints-button"
                onClick={returnToFunction}
            >
                <ArrowLeft className="back-to-datapoints-icon" />
                Return to {returnTo}
            </button>

            <div className="history-card">
                <div className="history-card-header">
                    <div className="section-navigation">
                        <div className="section-title">
                            <img 
                                src={CreateCloudfrontUrl(historyItem.icons.dark)} 
                                alt="" 
                                className="section-icon"
                            />
                            <span>{historyItem.section_label}</span>
                        </div>
                        <ChevronRight className="nav-chevron" />
                        <span className="subsection-label">{historyItem.sub_section_label}</span>
                    </div>
                </div>

                <div className="history-card-content">
                    <div className="content-header">
                        <h2 className="content-title">{historyItem.headline}</h2>
                        <p className="total-changes">Total changes: {sortedTimeline.length}</p>
                    </div>

                    <div className="timeline-container">
                        {/* <div className="timeline-line"></div> */}
                        <div className="timeline-points">
                            {sortedTimeline.map((change, index) => {
                                const date = new Date(change.time * 1000);
                                const formattedDate = date.toLocaleDateString('en-US', { 
                                    month: 'short', 
                                    day: 'numeric' 
                                });
                                const formattedTime = date.toLocaleTimeString('en-US', { 
                                    hour: 'numeric', 
                                    minute: '2-digit', 
                                    hour12: true 
                                });

                                const isMostRecent = index === 0;

                                return (
                                    <div key={change.time} className="timeline-point">
                                        <div className="change-info">
                                            <div className="change-date">
                                               <span className="change-date-day">{formattedDate}</span>
                                                <span className="change-date-time">({formattedTime})</span>
                                            </div>
                                            <div className="change-value-container">
                                                <span className="change-value">Changed to: {change.updated_to}</span>
                                            </div>
                                        </div>
                                        <button className={`revert-button ${isMostRecent ? 'most-recent' : 'past box-shadow-light'}`}>
                                            {isMostRecent ? 'Current Value' : 'Revert to This'}
                                        </button>
                                        <div className="point-marker"></div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DatapointHistory;
